module.exports = __webpack_public_path__ + "img/boro-purvi.2aaeea3d.jpg";